export class SingleCleanupConfigurationInfoView {
  constructor(
    public customerId: number,
    public periodFrom: number,
    public periodTo: number,
    public countries: Array<string>
  ) {}
}
